import { forwardRef, type SVGProps } from 'react';

export interface InsightsChartIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const InsightsChartIcon = forwardRef<SVGSVGElement, InsightsChartIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M9.5 7.5C9.776 7.5 10 7.724 10 8V14.5C10 14.776 9.776 15 9.5 15H6.5C6.224 15 6 14.776 6 14.5V8C6 7.724 6.224 7.5 6.5 7.5H9.5ZM7 14H9V8.5H7V14ZM14.5 5C14.776 5 15 5.224 15 5.5V14.5C15 14.776 14.776 15 14.5 15H11.5C11.224 15 11 14.776 11 14.5V5.5C11 5.224 11.224 5 11.5 5H14.5ZM12 14H14V6H12V14ZM4.5 10C4.776 10 5 10.224 5 10.5V14.5C5 14.776 4.776 15 4.5 15H1.5C1.224 15 1 14.776 1 14.5V10.5C1 10.224 1.224 10 1.5 10H4.5ZM2 14H4V11H2V14ZM10.145 1.148C10.339.952 10.655.95 10.852 1.145 11.048 1.339 11.05 1.655 10.855 1.852L7.394 5.352C7.3 5.447 7.172 5.5 7.039 5.5 6.905 5.5 6.777 5.446 6.683 5.352L4.269 2.911 1.855 5.352C1.661 5.548 1.345 5.55 1.148 5.355.952 5.161.95 4.845 1.145 4.648L3.914 1.849 3.951 1.815C4.04 1.741 4.152 1.7 4.269 1.7 4.403 1.7 4.531 1.754 4.624 1.849L7.038 4.289 10.145 1.148Z"
      fill="currentColor"
    />
  </svg>
));

InsightsChartIcon.displayName = 'InsightsChartIcon';
